/* eslint-disable prettier/prettier */
import navBar from "assets/i18next/fr/navBar";
import sideBar from "assets/i18next/fr/sideBar";
import mpsa from "assets/i18next/fr/mpsa";
import authentication from "assets/i18next/fr/authentication";
import message from "assets/i18next/fr/message"
import user from "assets/i18next/fr/user"
import global from "assets/i18next/fr/global"

const translation = Object.assign({}, navBar, sideBar, mpsa, authentication, message, user, global);
export default translation;
